<template>

<b-modal ref="bModal" :id="modalId" :title="title" size="xl"
         @shown="onShown" @hidden="onHidden" header-bg-variant="primary"
         header-text-variant="light" footer-class="justify-content-start" content-class="versionParent">
  <work-order-form v-model="workOrder" disabled/>
  <div v-if="versions" >
    <h5 class="font-weight-bold">Historial de Cambios</h5>
    <work-order-version-table :versions="versions" :workOrderType="workOrder.workOrderType"/>
  </div>

  <template slot="modal-footer">
    <div class="ml-auto">
      <b-button @click="$refs.bModal.hide()" variant="secondary">Cerrar</b-button>
      <b-button v-if="pdfURL" :href="pdfURL" target="_blank" variant="info">Ver PDF</b-button>
      <b-button v-if="permisoDelete" @click="onDelete" variant="danger">Eliminar</b-button>
    </div>
  </template>
</b-modal>

</template>

<script>

import WorkOrderVersionTable from '@/components/workOrderVersion/WorkOrderVersionTable'
import WorkOrderForm from './WorkOrderForm'
import api from '@/api/api'
import {session} from '@/auth'

export default {
  name: 'ShowWorkOrderModal',
  components: {
    WorkOrderVersionTable,
    WorkOrderForm
  },
  props: {
    modalId: {type: String, required: true},
    workOrder: {required: true}
  },
  data() {
    return {
      versions: null,
      pdfURL: null
    }
  },
  computed: {
    title() {
      return 'Parte de trabajo: PT' + this.workOrder.id + ' - ' + this.workOrder.typeLabel
    },
    permisoDelete() {
      if ((session.authorities != null) && session.authorities.includes('ROLE_WORK_ORDER_DELETE')) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    show() {
      this.$refs.bModal.show()
    },
    async onShown() {
      if (this.workOrder.workOrderType === 'ADM') {
        this.loadPDF()
      } else if (this.workOrder.workOrderType === 'PROJECT') {
        this.loadVersions()
      }
    },
    onHidden() {
      this.versions = null
      this.pdfURL = null
    },
    async loadPDF() {
      const workOrderBefore = this.workOrder
      const blob = await api.workOrder.getPDF(this.workOrder.id)

      if (workOrderBefore === this.workOrder) {
        this.pdfURL = URL.createObjectURL(blob)
      }
    },
    async loadVersions() {
      const workOrderBefore = this.workOrder
      const versions = await api.workOrder.getVersions(this.workOrder.id)

      if (workOrderBefore === this.workOrder) {
        this.versions = versions
      }
    },
    onDelete() {
      this.$emit('delete', this.workOrder)
      this.$refs.bModal.hide()
    }
  }
}

</script>

<style lang="scss">
  div#showModal___BV_modal_content_ {
    min-width: 1050px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/workOrder/partials/ShowWorkOrderModal.vue